var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.53499C3 11.8283 7.74667 15.2683 7.94667 15.4083C8.05957 15.4887 8.19473 15.5319 8.33333 15.5319C8.47193 15.5319 8.60709 15.4887 8.72 15.4083C8.92 15.2683 13.6667 11.8283 13.6667 7.53499C13.6667 6.12051 13.1048 4.76395 12.1046 3.76376C11.1044 2.76356 9.74782 2.20166 8.33333 2.20166C6.91884 2.20166 5.56229 2.76356 4.5621 3.76376C3.5619 4.76395 3 6.12051 3 7.53499ZM12.3333 7.53499C12.3333 10.495 9.40667 13.1483 8.33333 14.0217C7.26 13.1483 4.33333 10.495 4.33333 7.53499C4.33333 6.47413 4.75476 5.45671 5.50491 4.70657C6.25505 3.95642 7.27247 3.53499 8.33333 3.53499C9.3942 3.53499 10.4116 3.95642 11.1618 4.70657C11.9119 5.45671 12.3333 6.47413 12.3333 7.53499Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 8.86833C9.06971 8.86833 9.66667 8.27137 9.66667 7.53499C9.66667 6.79861 9.06971 6.20166 8.33333 6.20166C7.59695 6.20166 7 6.79861 7 7.53499C7 8.27137 7.59695 8.86833 8.33333 8.86833Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIcon);
export default __webpack_public_path__ + "static/media/loc-icon.d3aa7d5462af4d7cfd3eefb0129298ff.svg";
export { ForwardRef as ReactComponent };